import React from "react";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="container py-5">

      {/* ================= HERO SECTION ================= */}
      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <h1 className="display-5 fw-bold mb-3">
            বাংলাদেশে প্রথম সম্পূর্ণ ফ্রি{" "}
            <span className="text-primary">MCQ Practice Platform</span>
          </h1>

          <p className="lead">
            <strong>MCQ BD</strong> — বার কাউন্সিল, জুডিশিয়াল, BCS, NTSCA, 
            বিশ্ববিদ্যালয় ভর্তি ও বিভিন্ন প্রতিযোগিতামূলক পরীক্ষার জন্য 
            বিষয়ভিত্তিক এবং সিলেবাসভিত্তিক MCQ অনুশীলনের সবচেয়ে সহজ প্ল্যাটফর্ম।
            কোন অ্যাপ ইন্সটল নয়, কোন লগইন নয় — এক ক্লিকে শুরু করুন প্র্যাকটিস!
          </p>

          <Link to="/exam" className="btn btn-primary btn-lg mt-3">
            এখনই প্র্যাকটিস শুরু করুন →
          </Link>
        </div>

        <div className="col-md-6 text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt="MCQ Icon"
            className="img-fluid"
            style={{ maxWidth: "320px" }}
          />
        </div>
      </div>

      {/* ================= FEATURE GRID ================= */}
      <h2 className="text-center fw-bold mb-4">
        কেন <span className="text-primary">MCQ BD</span>?
      </h2>

      <div className="row text-center mt-4">
        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-primary">✔ ১০+ গুরুত্বপূর্ণ বিষয়</h4>
            <p>
              CrPC, CPC, Penal Code, Evidence Act, Tax, Ethics, Limitation—
              প্রতিটি বিষয়ই সিলেবাস অনুযায়ী সাজানো।
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-success">✔ সীমাহীন প্র্যাকটিস</h4>
            <p>
              Google Sheet থেকে অটো ডেটা লোড হয়—সব প্রশ্ন আপডেটেড
              এবং রিয়েল-টাইমে যুক্ত করা যায়।
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="fw-bold text-danger">✔ Timer + Score + Review</h4>
            <p>
              পরীক্ষার মতো পরিবেশ—Timer, Accuracy, Negative Marking,
              Review Mode এবং Result Summary।
            </p>
          </div>
        </div>
      </div>

      {/* ================= ABOUT PLATFORM SECTION ================= */}
      <div className="mt-5 p-4 bg-light rounded shadow-sm">
        <h3 className="fw-bold mb-3">MCQ BD প্ল্যাটফর্ম সম্পর্কে</h3>
        <p>
          MCQ BD এমন একটি অনলাইন লার্নিং প্ল্যাটফর্ম যেখানে শিক্ষার্থী ও পরীক্ষার্থীরা 
          খুব সহজেই বিষয়ভিত্তিক MCQ অনুশীলন করতে পারে। Judicial, Bar Council, BCS,
          University Admission—সব পরীক্ষার গ্রুপ অনুযায়ী সাজানো প্রশ্নব্যাংক এখানে পাওয়া যায়।
        </p>

        <ul>
          <li>Subject-wise Quiz</li>
          <li>MCQ-50 ও MCQ-100 সেট</li>
          <li>Shuffle Mode + Review Mode</li>
          <li>Finish Anytime (যেকোনো সময় পরীক্ষা শেষ)</li>
          <li>Google Sheet থেকে Dynamic Question Update</li>
        </ul>
      </div>

      {/* ================= CTA SECTION ================= */}
      <div className="text-center mt-5">
        <Link to="/exam" className="btn btn-dark btn-lg px-5 py-3">
          Start Exam Practice →
        </Link>

        <p className="mt-3 text-muted">
          প্রতিদিন অনুশীলন করুন, সাফল্য নিশ্চিত করুন।  
          <strong>MCQ BD — আপনার প্রস্তুতির স্মার্ট পার্টনার।</strong>
        </p>
      </div>
    </div>
  );
}
